import React from 'react'
import Login from './Login'
import { useLogin } from '../../utils/Hooks'

const AuthenticatedPage = ({ children, defaultProvider }) => {
    const user = useLogin()
    if (user) return children
    else return <Login providerType={defaultProvider} />
}
export default AuthenticatedPage